import { DEAD_ADDRESS, TRANSFER_TOPIC, VITALIK } from "../../integration.js";
import { CORE_PINNED_BLOCK_HASHES, CORE_PINNED_BLOCK_HEIGHTS, CORE_PINNED_TRANSACTION_HASHES } from "../pinned.js";
import { ERC20_BALANCE_OF_REFERENCE_CALLDATA } from "../fixture-inputs.js";
export const LINEA_TEST_CONFIG = {
    balance: { address: VITALIK },
    blockQuery: {
        block: CORE_PINNED_BLOCK_HEIGHTS.linea,
        fixture: "getBlockByNumberLinea",
    },
    balanceQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.linea,
        fixture: "getBalanceLinea",
    },
    tokenBalanceQuery: {
        address: VITALIK,
        token: "0x176211869cA2b568f2A7D4EE941E073a821EE1ff",
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.linea,
        fixture: "getTokenBalanceLinea",
    },
    blockHashQuery: {
        hash: CORE_PINNED_BLOCK_HASHES.linea,
        fixture: "getBlockByHashLinea",
    },
    blockTransactionsQuery: {
        blockNumber: CORE_PINNED_BLOCK_HEIGHTS.linea,
        fixture: "getBlockTransactionsLinea",
    },
    transfersQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.linea,
        fixture: "getTransfersLinea",
    },
    simulateCallQuery: {
        to: "0x176211869cA2b568f2A7D4EE941E073a821EE1ff",
        data: ERC20_BALANCE_OF_REFERENCE_CALLDATA,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.linea,
        fixture: "simulateCallLinea",
    },
    traceTransactionQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.linea,
        fixture: "traceTransactionLinea",
    },
    tokenMetadataQuery: {
        address: "0x176211869cA2b568f2A7D4EE941E073a821EE1ff",
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.linea,
        fixture: "getTokenMetadataLinea",
    },
    tokenAllowanceQuery: {
        token: "0x176211869cA2b568f2A7D4EE941E073a821EE1ff",
        owner: VITALIK,
        spender: DEAD_ADDRESS,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.linea,
        fixture: "getTokenAllowanceLinea",
    },
    portfolioQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.linea,
    },
    receiptQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.linea,
        fixture: "getReceiptLinea",
    },
    transactionByHashQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.linea,
        fixture: "getTransactionByHashLinea",
    },
    estimateGasQuery: {
        to: VITALIK,
        fixture: "estimateGasLinea",
    },
    codeQuery: {
        address: "0x176211869cA2b568f2A7D4EE941E073a821EE1ff",
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.linea,
        fixture: "getCodeLinea",
    },
    logsQuery: {
        // Linea USDC — 50-block window for log density.
        address: "0x176211869cA2b568f2A7D4EE941E073a821EE1ff",
        topic0: TRANSFER_TOPIC,
        fromBlock: String(CORE_PINNED_BLOCK_HEIGHTS.linea - 50),
        toBlock: String(CORE_PINNED_BLOCK_HEIGHTS.linea),
        fixture: "getLogsLinea",
    },
};
